import React from 'react';
import { Link } from 'react-router-dom';
import { faAngleRight, faTimes } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import './banner.css';

const AgnosticBannerDesktop = ({ closeBanner }) => (
  <div
    className="banner"
    style={{
      top: '80px',
      backgroundColor: '#2a7724',
      borderColor: '#2a7724'
    }}>
    <div className="banner__container container">
      <div className="banner__content">
        <div className="banner__details">
          Important Autzu changes starting March 4, 2020.
        </div>
        <Link to="./changesFAQ">
          <div className="banner__read-more">
            {' '}
            Read more on the website
          </div>
          <FontAwesomeIcon icon={faAngleRight} fixedWidth size="1x" />
        </Link>
      </div>
      <div className="banner__close" onClick={closeBanner}>
        <FontAwesomeIcon icon={faTimes} fixedWidth size="1x" />
      </div>
    </div>
  </div>
);

export default AgnosticBannerDesktop;



// WEBPACK FOOTER //
// ./src/components/Layout/AgnosticBannerDesktop.js